import locale from "@bonliva-crm/locale";
import { ConfirmDialogOptions } from "./ConfirmDialogOptions";
import { ConfirmDialogAction } from "./utils";

export type OkResult = "ok";

export class OkDialogOptions extends ConfirmDialogOptions<OkResult> {
  actions: Array<ConfirmDialogAction<OkResult>> = [
    {
      title: locale.OK,
      icon: null,
      type: "primary" as const,
      value: "ok" as OkResult,
      style: { marginLeft: "auto" }
    }
  ];

  constructor(
    public title: string = locale.AreYouSure,
    public message: string | null = null
  ) {
    super();
  }
}
